import { Routes } from '@angular/router';
import { NotImplementedComponent } from './not-implemented/not-implemented.component';
import { FEATURE_ROUTES } from './feature-routes';
import { EzLibShowcaseComponent } from '@template-ui/showcase/ez-lib-showcase.component';
import { protectRoute } from './protect-route';
import { AllUserRoles } from './enum/enumLookup';
import { LoginComponent } from './shared/components/login/login.component';
import { CallbackComponent } from './shared/components/callback/callback.component';
import { PlatformHomeComponent } from './platform-home/platform-home.component';

export const routes: Routes = [
    {
        path: 'login',
        component: LoginComponent,
        data: {
            tabTitle: 'Sign In',
            shellless: true,
        }
    },
    {
        path: 'callback',
        component: CallbackComponent,
        data: {
            tabTitle: 'Signing In',
            shellless: true,
        }
    },
    {
        path: "unauthorized",
        loadComponent: () =>
            import('./shared/components/unauthorized/unauthorized.component').then((m) => m.UnauthorizedComponent),
        data: {
            breadcrumb: ['Access Denied'],
            tabTitle: 'Access Denied',
            shellless: true,
        }
    },
    ...FEATURE_ROUTES.map(protectRoute),
    protectRoute({
        path: "home",
        component: PlatformHomeComponent,
        data: {
            breadcrumb: ['Platform Home'],
            tabTitle: 'Platform Home',
        },
    }),
    protectRoute({
        path: "dashboard",
        loadComponent: () =>
            import('./parole-dashboard/parole-dashboard.component').then((m) => m.ParoleDashboardComponent),
        data: {
            breadcrumb: ['Dashboard'],
            tabTitle: 'Dashboard',
        },
    }),
    protectRoute({
        path: "libraryShowcase",
        component: EzLibShowcaseComponent,
        data: {
            breadcrumb: ['Library Showcase'],
            tabTitle: 'Showcase',
            roles: [AllUserRoles.DEVTEAM],
        },
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'docs/Overview'
            },
            {
                path: 'docs/:docPath',
                data: {
                    breadcrumb: ['Showcase', '{{docPath}}'],
                    tabTitle: 'Showcase {{docPath}}',
                    roles: [AllUserRoles.DEVTEAM],
                },
                component: EzLibShowcaseComponent
            }
        ]
    }),
    protectRoute({
        path: "libraryShowcase/:libName/:className",
        component: EzLibShowcaseComponent,
        data: {
            breadcrumb: ['Showcase', '{{libName}}', '{{className}}'],
            roles: [AllUserRoles.DEVTEAM],
        },
        children: [
            {
                path: '**',
                component: EzLibShowcaseComponent,
                data: {
                    tabTitle: 'Showcase {{className}}',
                    roles: [AllUserRoles.DEVTEAM],
                }
            }
        ]
    }),
    protectRoute({
        path: "notImplemented",
        component: NotImplementedComponent,
        data: {
            breadcrumb: ['Not Implemented'],
            tabTitle: 'Coming Soon',
        }
    }),
    {
        path: "",
        pathMatch: "full",
        redirectTo: "login"
    }
];
